import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Header from './Header'
import Sidebar from './Sidebar'
import SurveyDetailsFlyout from './SurveyDetailsFlyout'
import useMobileLayout from '../../hooks/useMobileLayout'

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [detailsFlyoutOpen, setDetailsFlyoutOpen] = useState(false)
  const location = useLocation()
  const isMobile = useMobileLayout()

  // Close sidebar and flyout on route change (mobile)
  useEffect(() => {
    setSidebarOpen(false)
    setDetailsFlyoutOpen(false)
  }, [location.pathname])

  // Close sidebar on window resize to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setSidebarOpen(false)
      }
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Mobile layout - no header/sidebar, full screen for mobile components
  if (isMobile) {
    return (
      <div
        className="bg-slate-50 overflow-hidden"
        style={{ height: '100dvh' }}
      >
        <main className="h-full p-4 overflow-hidden">
          {children}
        </main>
      </div>
    )
  }

  return (
    <div className="h-screen bg-slate-50 overflow-hidden">
      <Header
        onMenuClick={() => setSidebarOpen(true)}
        onSurveyDetailsClick={() => setDetailsFlyoutOpen(true)}
      />

      <div className="flex h-[calc(100vh-64px)]">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        <main className="flex-1 min-h-0 p-4 lg:p-6 overflow-y-auto relative">
          {children}
        </main>
      </div>

      {/* Survey Details Flyout */}
      <SurveyDetailsFlyout
        isOpen={detailsFlyoutOpen}
        onClose={() => setDetailsFlyoutOpen(false)}
      />
    </div>
  )
}

// Full screen layout without sidebar (for camera mode)
export function FullScreenLayout({ children }) {
  return (
    <div className="min-h-screen bg-slate-900">
      {children}
    </div>
  )
}

// Simple layout with just header
export function SimpleLayout({ children, title }) {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-primary-700 text-white shadow-lg">
        <div className="flex items-center justify-between px-4 py-4">
          <h1 className="text-lg font-bold">{title || 'Clystcore Surveyors'}</h1>
        </div>
      </header>
      <main className="p-4">
        {children}
      </main>
    </div>
  )
}
